import type { AxiosResponse } from "axios";
import { InitService } from "./init.service";
import type Item from "./model/item";
import type ItemArvore from "./model/itemArvore";

export class LoteService extends InitService {

    async obterSituacoesLote(): Promise<AxiosResponse<Array<Item>>> {
        return await this.post('/Lote/ObterSituacoes', null, true);
    }

    async obterSituacoesLicitacao(): Promise<AxiosResponse<Array<Item>>> {
        return await this.get('Lote/ObterSituacoesLicitacao', true);
    }

    async obterSituacoesContrato(): Promise<AxiosResponse<Array<Item>>> {
        return await this.get('Lote/ObterSituacoesContrato', true);
    }

    async obterTiposObjetos(): Promise<AxiosResponse<Array<ItemArvore>>> {
        return await this.get('Lote/ObterTiposObjetos', true);
    }
}

const loteService = new LoteService();
export default loteService;